import Message from "base/Message";
import LastUpdatedHelper from "LastUpdatedHelper";
import ConfirmModal from "modal/ConfirmModal";

export default class TriggerUpdateModal extends ConfirmModal {
    constructor() {
        super("Are you sure you want to update the invoices from the spreadsheet?", "Are you sure?");

        this.bindEvents();
    }

    bindEvents() {
        this.on("confirm", async () => {
            if (this.isLoading()) {
                return;
            }

            this.showLoading();
            try {
                await Ajax.post("billing", "tasks/run-task", {task: "process-spreadsheets"});
                await Ajax.post("billing", "tasks/run-task", {task: "auto-link-subscription-entries"});
                await LastUpdatedHelper.update_time();
                new Message("The invoices have been successfully updated. You will need to reload before seeing any changes.", "Invoices Updated", Message.SUCCESS);
                this.destroy();
            } catch (e) {
                new Message(e.message, "An error occurred", Message.ERROR, {
                    autoHide: false,
                });
                this.stopLoading();
            }
        }).on("cancel", () => this.destroy());
    }
}
